(function () {
  if (window.__AG_PB_PD_GALLERY_INIT__) return;
  window.__AG_PB_PD_GALLERY_INIT__ = true;

  function updateSaveBadge(root, pct) {
    var scope = root || document;
    var badges = scope.querySelectorAll
      ? scope.querySelectorAll('[data-ag-pb-pd-gallery-badge]')
      : [];
    if (!badges.length && scope.matches && scope.matches('[data-ag-pb-pd-gallery-badge]')) {
      badges = [scope];
    }
    var discounts = scope.querySelectorAll
      ? scope.querySelectorAll('[data-ag-pb-pd-countdown-discount]')
      : [];
    var n = parseInt(pct, 10);
    if (isNaN(n)) n = 0;

    Array.prototype.forEach.call(badges, function (badge) {
      if (n > 0) {
        var prefix = (badge.getAttribute('data-badge-prefix') || 'save').trim();
        var label = (prefix ? prefix + ' ' : '') + n + '%';
        var textEl = badge.querySelector('.ag-pb-pd__gallery-badge-text');
        if (textEl) textEl.textContent = label;
        else badge.textContent = label;
        badge.hidden = false;
      } else {
        badge.hidden = true;
      }
    });

    /* PD countdown heading — same variant save %, no "save" prefix */
    Array.prototype.forEach.call(discounts, function (el) {
      if (n > 0) {
        el.textContent = n + '%';
        el.hidden = false;
      } else {
        el.hidden = true;
      }
    });
  }

  function bindDragScroll(el) {
    if (!el || el.dataset.agPbPdDragBound === 'true') return;
    el.dataset.agPbPdDragBound = 'true';

    var isDown = false;
    var startX = 0;
    var startScroll = 0;
    var moved = false;
    var suppressClick = false;

    var startY = 0;
    var axisLocked = null;

    function onDown(clientX, clientY) {
      isDown = true;
      moved = false;
      axisLocked = null;
      startX = clientX;
      startY = clientY || 0;
      startScroll = el.scrollLeft;
      el.classList.add('is-dragging');
    }

    function onMove(clientX, clientY, event) {
      if (!isDown) return;
      var dx = clientX - startX;
      var dy = (clientY || 0) - startY;

      if (axisLocked == null && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) {
        axisLocked = Math.abs(dx) >= Math.abs(dy) ? 'x' : 'y';
        if (axisLocked === 'y') {
          isDown = false;
          el.classList.remove('is-dragging');
          return;
        }
      }
      if (axisLocked !== 'x') return;

      if (Math.abs(dx) > 4) moved = true;
      el.scrollLeft = startScroll - dx;
      if (moved && event && event.cancelable) event.preventDefault();
    }

    function onUp() {
      if (!isDown && axisLocked !== 'x') {
        el.classList.remove('is-dragging');
        return;
      }
      if (!isDown) return;
      isDown = false;
      axisLocked = null;
      el.classList.remove('is-dragging');
      if (moved) {
        suppressClick = true;
        window.setTimeout(function () { suppressClick = false; }, 0);
      }
    }

    el.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      onDown(e.clientX, e.clientY);
    });

    window.addEventListener('mousemove', function (e) {
      onMove(e.clientX, e.clientY, e);
    });

    window.addEventListener('mouseup', onUp);

    el.addEventListener('touchstart', function (e) {
      if (!e.touches || !e.touches[0]) return;
      onDown(e.touches[0].clientX, e.touches[0].clientY);
    }, { passive: true });

    el.addEventListener('touchmove', function (e) {
      if (!e.touches || !e.touches[0]) return;
      onMove(e.touches[0].clientX, e.touches[0].clientY, e);
    }, { passive: false });

    el.addEventListener('touchend', onUp);
    el.addEventListener('touchcancel', onUp);

    el.addEventListener('click', function (e) {
      if (!suppressClick) return;
      e.preventDefault();
      e.stopPropagation();
    }, true);

    el.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });
  }

  function initGallery(root) {
    if (!root || root.dataset.agPbPdGalleryReady === 'true') return;

    var track = root.querySelector('[data-ag-pb-pd-gallery-track]');
    var slides = Array.prototype.slice.call(
      root.querySelectorAll('[data-ag-pb-pd-gallery-slide]')
    );
    var thumbs = Array.prototype.slice.call(
      root.querySelectorAll('[data-ag-pb-pd-gallery-thumb]')
    );
    if (!track || !slides.length) return;

    root.dataset.agPbPdGalleryReady = 'true';

    var index = 0;
    var prevBtn = root.querySelector('[data-ag-pb-pd-gallery-prev]');
    var nextBtn = root.querySelector('[data-ag-pb-pd-gallery-next]');
    var thumbsWrap = root.querySelector('[data-ag-pb-pd-gallery-thumbs]');
    var viewport = root.querySelector('[data-ag-pb-pd-gallery-viewport]');

    /* Slides past the first start on a placeholder src (see ag-pb-pd-gallery.liquid) so they
       don't download alongside the LCP image. Overflow-hidden track images never lazy-load
       on their own, so the real sources are set once the page has loaded, or sooner when the
       visitor touches the gallery. */
    var slidesActive = false;
    function activateSlides() {
      if (slidesActive) return;
      slidesActive = true;
      Array.prototype.forEach.call(track.querySelectorAll('img[data-ag-pb-pd-src]'), function (img) {
        var srcset = img.getAttribute('data-ag-pb-pd-srcset');
        if (srcset) img.srcset = srcset;
        img.src = img.getAttribute('data-ag-pb-pd-src');
        img.removeAttribute('data-ag-pb-pd-src');
        img.removeAttribute('data-ag-pb-pd-srcset');
      });
    }

    /* A gallery inside a hidden container (e.g. quiz results) keeps its placeholders until it is shown. */
    function activateWhenRendered() {
      if (root.getClientRects().length > 0 || !('IntersectionObserver' in window)) {
        activateSlides();
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        io.disconnect();
        activateSlides();
      }, { rootMargin: '600px 0px' });
      io.observe(root);
    }

    if (document.readyState === 'complete' || (window.Shopify && window.Shopify.designMode)) {
      activateWhenRendered();
    } else {
      window.addEventListener('load', activateWhenRendered, { once: true });
      window.setTimeout(activateWhenRendered, 3000);
      ['pointerdown', 'touchstart', 'keydown', 'focusin'].forEach(function (type) {
        root.addEventListener(type, activateSlides, { once: true, passive: true });
      });
    }

    /* Pin active thumb flush to left edge of the strip (not centered).
       Use getBoundingClientRect — thumb offsetLeft is wrong when thumbs are position:relative. */
    function scrollActiveThumbToStart(thumb) {
      if (!thumb || !thumbsWrap) return;
      if (thumbsWrap.scrollWidth <= thumbsWrap.clientWidth + 1) {
        thumbsWrap.scrollLeft = 0;
        return;
      }

      var wrapRect = thumbsWrap.getBoundingClientRect();
      var thumbRect = thumb.getBoundingClientRect();
      var delta = thumbRect.left - wrapRect.left;
      var maxScroll = Math.max(0, thumbsWrap.scrollWidth - thumbsWrap.clientWidth);
      var left = Math.max(0, Math.min(thumbsWrap.scrollLeft + delta, maxScroll));

      if (typeof thumbsWrap.scrollTo === 'function') {
        thumbsWrap.scrollTo({ left: left, behavior: 'smooth' });
      } else {
        thumbsWrap.scrollLeft = left;
      }
    }

    function applyTrackTransform(slideIndex, dragPx) {
      var width = viewport ? viewport.clientWidth : 0;
      var offsetPct = slideIndex * 100;
      if (dragPx && width > 0) {
        offsetPct -= (dragPx / width) * 100;
      }
      track.style.transform = 'translateX(-' + offsetPct + '%)';
    }

    function isMediaControl(target) {
      if (!target || !target.closest) return false;
      var wrap = target.closest('[data-ag-pb-pd-gallery-video]');
      if (!wrap || !wrap.classList.contains('is-playing')) return false;
      return !!target.closest('video, iframe');
    }

    function resetVideoWrap(wrap) {
      if (!wrap) return;
      wrap.classList.remove('is-playing');
      var hit = wrap.querySelector('[data-ag-pb-pd-gallery-play]');
      if (hit) hit.hidden = false;
      Array.prototype.forEach.call(wrap.querySelectorAll('video'), function (video) {
        if (!video.paused) video.pause();
      });
      Array.prototype.forEach.call(wrap.querySelectorAll('iframe'), function (frame) {
        var original = frame.dataset.agPbPdSrc;
        if (!original) return;
        if (frame.src !== original) frame.src = original;
      });
    }

    function playVideoWrap(wrap) {
      if (!wrap || wrap.classList.contains('is-playing')) return;
      wrap.classList.add('is-playing');
      var hit = wrap.querySelector('[data-ag-pb-pd-gallery-play]');
      if (hit) hit.hidden = true;

      var video = wrap.querySelector('video');
      if (video) {
        var playPromise = video.play();
        if (playPromise && playPromise.catch) {
          playPromise.catch(function () {
            wrap.classList.remove('is-playing');
            if (hit) hit.hidden = false;
          });
        }
      }

      var iframe = wrap.querySelector('iframe');
      if (iframe) {
        var src = iframe.getAttribute('src') || '';
        if (!iframe.dataset.agPbPdSrc) iframe.dataset.agPbPdSrc = src;
        var next = iframe.dataset.agPbPdSrc || src;
        if (next && next.indexOf('autoplay=1') === -1) {
          next += (next.indexOf('?') >= 0 ? '&' : '?') + 'autoplay=1';
        }
        if (next) iframe.src = next;
      }
    }

    function pauseInactiveMedia(activeIndex) {
      slides.forEach(function (slide, i) {
        if (i === activeIndex) return;
        resetVideoWrap(slide.querySelector('[data-ag-pb-pd-gallery-video]'));
      });
    }

    function bindVideoPlay() {
      slides.forEach(function (slide) {
        var wrap = slide.querySelector('[data-ag-pb-pd-gallery-video]');
        if (!wrap || wrap.dataset.agPbPdVideoBound === 'true') return;
        wrap.dataset.agPbPdVideoBound = 'true';

        var hit = wrap.querySelector('[data-ag-pb-pd-gallery-play]');
        var video = wrap.querySelector('video');

        if (hit) {
          hit.addEventListener('click', function (e) {
            e.preventDefault();
            playVideoWrap(wrap);
          });
        }

        if (video) {
          video.addEventListener('ended', function () {
            resetVideoWrap(wrap);
          });
        }
      });
    }

    function setActive(nextIndex) {
      var total = slides.length;
      index = ((nextIndex % total) + total) % total;

      track.classList.remove('is-dragging');
      applyTrackTransform(index, 0);
      pauseInactiveMedia(index);

      slides.forEach(function (slide, i) {
        var active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (active) slide.removeAttribute('inert');
        else slide.setAttribute('inert', '');
      });

      thumbs.forEach(function (thumb, i) {
        var active = i === index;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
      });

      /* Wait a frame so active border/layout settles, then pin to start */
      window.requestAnimationFrame(function () {
        scrollActiveThumbToStart(thumbs[index]);
      });
    }

    function bindMainDrag() {
      if (!viewport || slides.length < 2) return;

      var dragging = false;
      var axisLocked = null;
      var startX = 0;
      var startY = 0;
      var dragPx = 0;
      var pointerId = null;
      var startPlayWrap = null;

      function onDown(clientX, clientY, id, event) {
        startPlayWrap = null;
        if (event && event.target) {
          if (event.target.closest('[data-ag-pb-pd-gallery-prev], [data-ag-pb-pd-gallery-next]')) {
            return;
          }
          if (isMediaControl(event.target)) return;
          var wrap = event.target.closest('[data-ag-pb-pd-gallery-video]:not(.is-playing)');
          if (wrap) startPlayWrap = wrap;
        }
        dragging = true;
        axisLocked = null;
        startX = clientX;
        startY = clientY;
        dragPx = 0;
        pointerId = id;
        track.classList.add('is-dragging');
        viewport.classList.add('is-dragging');
      }

      function onMove(clientX, clientY, event) {
        if (!dragging) return;
        var dx = clientX - startX;
        var dy = clientY - startY;

        if (axisLocked == null && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) {
          axisLocked = Math.abs(dx) >= Math.abs(dy) ? 'x' : 'y';
          if (axisLocked === 'y') {
            dragging = false;
            track.classList.remove('is-dragging');
            viewport.classList.remove('is-dragging');
            applyTrackTransform(index, 0);
            return;
          }
        }
        if (axisLocked !== 'x') return;

        dragPx = dx;
        /* Rubber-band at ends */
        if ((index === 0 && dragPx > 0) || (index === slides.length - 1 && dragPx < 0)) {
          dragPx = dragPx * 0.35;
        }
        applyTrackTransform(index, dragPx);
        if (event && event.cancelable) event.preventDefault();
      }

      function onUp() {
        if (!dragging && axisLocked !== 'x') {
          track.classList.remove('is-dragging');
          viewport.classList.remove('is-dragging');
          startPlayWrap = null;
          return;
        }
        if (!dragging && axisLocked == null) {
          startPlayWrap = null;
          return;
        }

        var width = viewport.clientWidth || 1;
        var threshold = Math.max(40, width * 0.18);
        var movedEnough = Math.abs(dragPx) >= threshold;
        var next = index;
        if (dragPx <= -threshold) next = index + 1;
        else if (dragPx >= threshold) next = index - 1;

        var playWrap = startPlayWrap;
        startPlayWrap = null;
        dragging = false;
        axisLocked = null;
        dragPx = 0;
        pointerId = null;
        viewport.classList.remove('is-dragging');
        setActive(next);
        if (!movedEnough && playWrap && next === index) {
          playVideoWrap(playWrap);
        }
      }

      if (window.PointerEvent) {
        viewport.addEventListener('pointerdown', function (e) {
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          onDown(e.clientX, e.clientY, e.pointerId, e);
          try { viewport.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ }
        });
        viewport.addEventListener('pointermove', function (e) {
          if (pointerId != null && e.pointerId !== pointerId) return;
          onMove(e.clientX, e.clientY, e);
        });
        viewport.addEventListener('pointerup', onUp);
        viewport.addEventListener('pointercancel', onUp);
      } else {
        viewport.addEventListener('mousedown', function (e) {
          if (e.button !== 0) return;
          onDown(e.clientX, e.clientY, null, e);
        });
        window.addEventListener('mousemove', function (e) { onMove(e.clientX, e.clientY, e); });
        window.addEventListener('mouseup', onUp);
        viewport.addEventListener('touchstart', function (e) {
          if (!e.touches || !e.touches[0]) return;
          onDown(e.touches[0].clientX, e.touches[0].clientY, null, e);
        }, { passive: true });
        viewport.addEventListener('touchmove', function (e) {
          if (!e.touches || !e.touches[0]) return;
          onMove(e.touches[0].clientX, e.touches[0].clientY, e);
        }, { passive: false });
        viewport.addEventListener('touchend', onUp);
        viewport.addEventListener('touchcancel', onUp);
      }

      viewport.addEventListener('dragstart', function (e) { e.preventDefault(); });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { setActive(index - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { setActive(index + 1); });

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var i = parseInt(thumb.getAttribute('data-index'), 10);
        if (!isNaN(i)) setActive(i);
      });
    });

    if (thumbsWrap) bindDragScroll(thumbsWrap);
    bindMainDrag();
    bindVideoPlay();

    if (root.getAttribute('tabindex') == null) {
      root.setAttribute('tabindex', '0');
    }

    root.addEventListener('keydown', function (e) {
      if (isMediaControl(e.target)) return;
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        setActive(index - 1);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        setActive(index + 1);
      }
    });

    setActive(0);
  }

  /*
    Theme sets html { overflow-x: clip }, which disables CSS position:sticky.
    Desktop pin/unpin polyfill relative to the PD layout column.
  */
  function bindDesktopSticky(gallery) {
    if (!gallery || gallery.dataset.agPbPdStickyBound === 'true') return;
    gallery.dataset.agPbPdStickyBound = 'true';

    var col = gallery.closest('.ag-pb-pd__gallery-col');
    var layout = gallery.closest('.ag-pb-pd__layout');
    if (!col || !layout) return;

    /* Matches the two-column breakpoint in ag-pb-block-product-details.css —
       below it the gallery and info stack, so there is nothing to pin against. */
    var mq = window.matchMedia('(min-width: 1000px)');
    var ticking = false;

    function headerOffset() {
      var raw = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
      var n = parseFloat(raw);
      return (isNaN(n) ? 80 : n) + 16;
    }

    function clearPin() {
      gallery.classList.remove('is-sticky-fixed', 'is-sticky-bottom');
      gallery.style.position = '';
      gallery.style.top = '';
      gallery.style.left = '';
      gallery.style.width = '';
      gallery.style.zIndex = '';
    }

    function update() {
      ticking = false;

      if (!mq.matches) {
        clearPin();
        return;
      }

      var offset = headerOffset();
      var layoutRect = layout.getBoundingClientRect();
      var colRect = col.getBoundingClientRect();
      var galleryH = gallery.offsetHeight;
      var colW = col.clientWidth;

      if (galleryH <= 0 || colW <= 0) {
        clearPin();
        return;
      }

      /* Not scrolled far enough — natural flow */
      if (layoutRect.top > offset) {
        clearPin();
        return;
      }

      /*
        Always use position:fixed + viewport left from the column.
        Absolute left:0 was resolving against a wide ancestor → jump to screen edge.
      */
      var topPx = offset;
      var atBottom = layoutRect.bottom - galleryH <= offset;
      if (atBottom) {
        topPx = layoutRect.bottom - galleryH;
      }

      gallery.classList.toggle('is-sticky-bottom', atBottom);
      gallery.classList.add('is-sticky-fixed');
      gallery.style.position = 'fixed';
      gallery.style.top = topPx + 'px';
      gallery.style.left = colRect.left + 'px';
      gallery.style.width = colW + 'px';
      gallery.style.zIndex = '2';
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', requestUpdate);
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(requestUpdate);
    }

    requestUpdate();
  }

  function bindSavePercentSync(detailsRoot) {
    if (!detailsRoot || detailsRoot.dataset.agPbPdSaveBound === 'true') return;
    detailsRoot.dataset.agPbPdSaveBound = 'true';

    function readSavePercent(el) {
      if (!el || !el.getAttribute) return null;
      return el.getAttribute('data-ag-pb-pd-save-percent') || el.getAttribute('data-save-percent');
    }

    detailsRoot.addEventListener('click', function (e) {
      var card = e.target.closest('[data-ag-pb-pd-save-percent], [data-save-percent]');
      if (!card || !detailsRoot.contains(card)) return;
      updateSaveBadge(detailsRoot, readSavePercent(card));
    });

    detailsRoot.addEventListener('change', function (e) {
      var el = e.target;
      if (!el || !el.getAttribute) return;
      var pct = readSavePercent(el);
      if (pct != null) {
        updateSaveBadge(detailsRoot, pct);
        return;
      }
      var wrap = el.closest('[data-ag-pb-pd-save-percent], [data-save-percent]');
      if (wrap) updateSaveBadge(detailsRoot, readSavePercent(wrap));
    });
  }

  function initAll(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-ag-pb-pd-gallery]').forEach(function (gallery) {
      initGallery(gallery);
      bindDesktopSticky(gallery);
    });
    root.querySelectorAll('[data-ag-pb-product-details]').forEach(bindSavePercentSync);
    if (root.matches && root.matches('[data-ag-pb-product-details]')) {
      bindSavePercentSync(root);
    }
  }

  document.addEventListener('ag-pb-pd:save-percent', function (event) {
    var pct = event && event.detail ? event.detail.percent : null;
    var target = event && event.detail && event.detail.root
      ? event.detail.root
      : document;
    updateSaveBadge(target, pct);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
  document.addEventListener('shopify:block:select', function (event) {
    initAll(event.target);
  });
})();
